import * as React from "react";
import { SVGProps } from "react";

const Strong = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    id="STRONG_Token"
    x={0}
    y={0}
    viewBox="0 0 563 563"
    {...props}
  >
    <style>{".st0{fill:#0e67ae}"}</style>
    <path
      d="M111.6 119.1h234c.7 0 1.3.2 1.8.6l95.2 70c1.4 1 1.6 2.9.6 4.3-.6.8-1.5 1.2-2.5 1.2H193.6c-1.7 0-3.1 1.4-3.1 3.1V288c0 1.7 1.4 3.1 3.1 3.1h157.5c1.7 0 3.1 1.4 3.1 3.1v65.4c0 1.7-1.4 3.1-3.1 3.1H110.5c-1.7 0-3.1-1.4-3.1-3.1l1.1-237.3c0-1.8 1.3-3.1 3.1-3.2-.1 0 0 0 0 0z"
      className="st0"
    />
    <path
      d="M448.9 450.8H205.4c-.7 0-1.3-.2-1.8-.6L114.1 384c-1.4-1-1.6-2.9-.6-4.3.6-.8 1.5-1.2 2.5-1.2h251c1.7 0 3.1-1.4 3.1-3.1v-97.3c0-1.7-1.4-3.1-3.1-3.1H211.8c-1.7 0-3.1-1.4-3.1-3v-57.7c0-1.7 1.4-3.1 3-3.1H450c1.7 0 3.1 1.4 3.1 3.1L452 447.8c-.1 1.7-1.4 3-3.1 3z"
      className="st0"
    />
    <circle
      cx={281.6}
      cy={281.6}
      r={268.6}
      fill="none"
      stroke="#0e67ae"
      strokeMiterlimit={10}
      strokeWidth={26}
    />
  </svg>
);

export default Strong;
